import React from 'react'

import "./App.css";
import susan from "./assets/susan.jpg"
import InstagramImg from "./assets/social/instagram.svg"
import wppImg from "./assets/social/wpp.svg"

import Renders from './components/Renders';
import Service from './components/Services';
import ResponsiveCarousel from './components/Carousel';
import outsourced from './constants/outsourced';

function App() {
  return (
    <div className="container">
      <section id='personal' className="personal">
        <div className='imgContainer'>
          <h1 className="name">Susan Groth</h1>
          <h3
            style={{
              margin: 0,
              fontFamily: "Josefin Sans",
              fontWeight: 400,
              fontSize: "calc(5px + 2vw)",
            }}
            className="name"
          >
            Arquiteta
          </h3>
        </div>
      </section>
      <section id="renders" className="renders">
        <Renders/>
      </section>
      <section id="outsourced" className="ads">
        <h1 style={{fontSize: 'calc(16px + 2vw)', marginLeft: '5%'}}>Projetos Terceirizados</h1>
        <ResponsiveCarousel images={outsourced.main.images} redirect urlField='projectUrl' imageField='image'/>
      </section>
      <section id="services" style={{marginTop: '5%'}} >
        <Service />
      </section>
      <section id="whoami" >
        <div className="about-container">
          <div className="picture">
            <img
              style={{
                borderRadius: "5px",
              }}
              alt="Arquiteta"
              src={susan}
            />
          </div>
          <div className="about-text">
            <h1>Susan Groth</h1>
            <p>
              Arquiteta, formada em 2022 pela Unochapecó, atuo oferecendo serviços terceirizados, com o objetivo de facilitar a rotina de outros arquitetos e designers, assumindo tarefas específicas e colaborando para a entrega de projetos com excelência e agilidade.
            </p>
          </div>
        </div>
      </section>
      <section id="contact">
        <h1 style={{fontSize: 'calc(16px + 2vw)', marginLeft: '5%', marginTop: 0}}>Entre em contato</h1>
        <div className="contact-container">
          <div className='contact-content'>
            <h1>
              Localização
            </h1>
            <p style={{width: '60%', textAlign: 'center'}}>Atendimento on-line para todo o território nacional.</p>
          </div>        
          <div className='contact-content'>
            <h1 >
              Instagram
            </h1>
            <a
              style={{display: 'flex', alignItems: 'center'}}
              target="_blank"
              className='icon-hover' 
              href="https://www.instagram.com/susangroth.arq" rel="noreferrer"
            >
              <img width={32} src={InstagramImg} /> - @susangroth.arq
            </a>
          </div>        
          <div className='contact-content'>
            <h1 >
              Email
            </h1>
            <a href='mailto:arq.susangroth@gmail.com'>
            arq.susangroth@gmail.com
            </a>
          </div>        
          <div className='contact-content'>
            <h1 >
              Orçamento
            </h1>
            <div className='bugdet-container'>
              <a target='_blank' href='https://forms.gle/MdVPr3e3zkSNUCt78' rel="noreferrer">Serviços terceirizados</a>
              <a style={{display: 'flex', alignItems: 'end', cursor: 'pointer', marginTop: '5px'}} target='_blank' className='icon-hover' href='https://wa.me/555496016240' rel="noreferrer">
                <img width={26} src={wppImg} /> 
                <label style={{marginLeft: '5px'}}>- WhatsApp</label>
              </a>
            </div>
          </div>        
        </div>
      </section>
    </div>
    
  );
}

export default App;
